import React from 'react';

import { DisputeType } from '@common/graphql';

const DISPUTE_TYPE_LABEL_OVERWRITE: Record<DisputeType, string> = {
  error: 'Error',
  missing_line: 'Missing Line',
} as const;

export const DisputeTypeDisplay = ({ type }: { type: DisputeType }) => (
  <div>{DISPUTE_TYPE_LABEL_OVERWRITE[type]}</div>
);
